const uuidv4 = require('uuid').v4
const { WAREHOUSE_DEFINITIONS } = require('../../order/tools/read/warehouse-code-to-virtual')

const transformWarehouseData = (organisationId, bulkRawStockData, username) => {
  const timestamp = new Date()
  return bulkRawStockData
    .map(rawStockData => {
      const item = rawStockData.data

      if (!item.sapCode.trim()) {
        return null
      }

      // Get UUID from RMS warehouse code
      const warehouseCode = item.valuationArea
      let locationId = null
      if (warehouseCode && WAREHOUSE_DEFINITIONS.RMS && WAREHOUSE_DEFINITIONS.RMS[warehouseCode]) {
        locationId = WAREHOUSE_DEFINITIONS.RMS[warehouseCode].uuid
      }

      return {
        id: uuidv4(),
        location_id: locationId,
        organisation_id: organisationId,
        sku: item.sapCode.trim(),
        date: timestamp,
        closing: parseInt(item.totalStock) || 0,
        source: item.valuationArea,
        created_at: timestamp,
        updated_at: timestamp,
        created_by: username,
        updated_by: username
      }
    })
}

module.exports = { transformWarehouseData }
